import { Components, Theme } from "@mui/material/styles";

export const skeletonComponentOverrides: Components<Theme>["MuiSkeleton"] = {
  styleOverrides: {
    root: ({ theme }) => ({
      backgroundColor: theme.palette.grey[100],
    }),
  },
};
